export const ATTACHMENT_SPINNER_HTML =
  '<span class="upload-overlay"><span class="upload-spinner" aria-hidden="true"></span></span>';

export function bindIncomingImageAttachmentLoading(messageEl) {
  if (!messageEl) return;
  messageEl.querySelectorAll('.attachment-loading.attachment-thumb').forEach((el) => {
    const img = el.querySelector('img');
    if (!img) {
      finalizeAttachmentLoading(el);
      return;
    }
    if (img.complete && img.naturalWidth > 0) {
      finalizeAttachmentLoading(el);
      return;
    }
    img.addEventListener('load', () => finalizeAttachmentLoading(el), { once: true });
    img.addEventListener('error', () => finalizeAttachmentLoading(el), { once: true });
  });
}

function finalizeAttachmentLoading(el) {
  el.querySelectorAll('.upload-overlay').forEach((o) => o.remove());
  el.classList.remove('attachment-loading');
}
